export default __webpack_public_path__ + "static/media/illustration-resetPW.e5265965.svg";